<app-header [user]="user" (childOuter)="getData($event)" [ngStyle]="{position: 'fixed', top: '0', left: '0', width: '100%', zIndex: '10'}"></app-header>
<mat-sidenav-container class="agent-portal-container">
  <mat-sidenav #sidenav mode="side" opened>
    <app-left-nav [user]="user"></app-left-nav>
  </mat-sidenav>
  <mat-sidenav-content>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>